import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const PapperClip = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.4566 5.28064C31.7093 5.28064 30.0337 5.97473 28.7982 7.21021L9.65235 26.356C7.63503 28.3734 6.50171 31.1094 6.50171 33.9624C6.50171 36.8153 7.63503 39.5514 9.65235 41.5687C11.6697 43.586 14.4057 44.7193 17.2587 44.7193C20.1116 44.7193 22.8477 43.586 24.865 41.5687L44.0108 22.4228C44.6942 21.7394 45.8023 21.7394 46.4857 22.4228C47.1691 23.1063 47.1691 24.2143 46.4857 24.8977L27.3398 44.0435C24.6661 46.7172 21.0398 48.2193 17.2587 48.2193C13.4775 48.2193 9.85117 46.7172 7.17747 44.0435C4.50378 41.3699 3.00171 37.7435 3.00171 33.9624C3.00171 30.1812 4.50378 26.5549 7.17747 23.8812L26.3233 4.73534C28.2152 2.84348 30.7811 1.78064 33.4566 1.78064C36.1321 1.78064 38.698 2.84348 40.5898 4.73534C42.4817 6.6272 43.5445 9.19311 43.5445 11.8686C43.5445 14.5441 42.4817 17.11 40.5898 19.0019L21.4232 38.1477C20.3132 39.2577 18.8076 39.8813 17.2378 39.8813C15.668 39.8813 14.1625 39.2577 13.0525 38.1477C11.9424 37.0377 11.3188 35.5322 11.3188 33.9624C11.3188 32.3925 11.9424 30.887 13.0525 29.777L30.7407 12.1096C31.4245 11.4266 32.5326 11.4272 33.2156 12.1111C33.8986 12.7949 33.8979 13.9029 33.2141 14.5859L15.5273 32.2519C15.0737 32.7055 14.8188 33.3208 14.8188 33.9624C14.8188 34.6039 15.0737 35.2192 15.5273 35.6728C15.981 36.1265 16.5963 36.3813 17.2378 36.3813C17.8794 36.3813 18.4947 36.1265 18.9483 35.6728L38.115 16.527C39.3505 15.2915 40.0445 13.6158 40.0445 11.8686C40.0445 10.1214 39.3505 8.44569 38.115 7.21021C36.8795 5.97473 35.2038 5.28064 33.4566 5.28064Z"
        fill={color}
      />
    </svg>
  )
}
